export const GET_WORKSHOP = 'GET_WORKSHOP';
export const RESET_WORKSHOP = 'RESET_WORKSHOP';
